import { formField, docuSignLink, programTime } from "./config";

export default function getLink(data: any, school: string, checked: boolean) {
  function get(field: any) {
    return data.get(field).trim();
  }

  const parent_first = get("parent_first");
  const parent_last = get("parent_last");
  const parent_middle = get("parent_middle");
  const parent_email = get("parent_email");
  const parent_phone = get("parent_phone");
  const parent_street = get("parent_street");
  const parent_city = get("parent_city");
  const parent_state = get("parent_state");
  const parent_postal_code = get("parent_postal_code");
  const parent_address = `${parent_street}, ${parent_city}, ${parent_state} ${parent_postal_code}`;

  const student_first = get("student_first");
  const student_last = get("student_last");
  const student_middle = get("student_middle");
  const student_street = checked ? get("parent_street") : get("student_street");
  const student_city = checked ? get("parent_city") : get("student_city");
  const student_state = checked ? get("parent_state") : get("student_state");
  const student_postal_code = checked
    ? get("parent_postal_code")
    : get("student_postal_code");
  const student_address = `${student_street}, ${student_city}, ${student_state} ${student_postal_code}`;
  const student_birthdate = get("student_birthdate");

  const parent_name =
    parent_middle === ""
      ? `${parent_first} ${parent_last}`
      : `${parent_first} ${parent_middle} ${parent_last}`;
  const student_name =
    student_middle === ""
      ? `${student_first} ${student_last}`
      : `${student_first} ${student_middle} ${student_last}`;
  const school_name = school.replace("&", "%26");

  const base_link = docuSignLink;

  const formData: { [key: string]: string } = {
    A_student_address: student_address,
    A_parent_first: parent_first,
    A_parent_last: parent_last,
    A_parent_middle: parent_middle,
    A_student_first: student_first,
    A_student_last: student_last,
    A_student_middle: student_middle,
    A_student_birthday: student_birthdate,
    A_parent_phone: parent_phone,
    B_parent_name: parent_name,
    C_student_name: student_name,
    D_parent_address: parent_address,
    D_student_name: `${student_name} (${school_name})`,
    A_program_name: `MIT Science Olympiad (as part of ${school_name})`,
    A_program_time: programTime,
  };

  let full_link =
    base_link +
    `&Parent/Guardian_UserName=${parent_name}` +
    `&Parent/Guardian_Email=${parent_email}`;

  for (const key in formField) {
    full_link += `&${formField[key]}=${formData[key]}`;
  }

  return full_link.replace(" ", "%20");
}
